var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('headTop',{staticStyle:{"position":"absolute","top":"50px","width":"100%"},attrs:{"getleft":_vm.showArrow,"showUser":_vm.showUser,"isHome":_vm.Home}}),_vm._v(" "),_c('div',{staticClass:"title_bg"},[_vm._v("综合营运管理平台")]),_vm._v(" "),_c('systemIn'),_vm._v(" "),_c('role')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-09747e18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/view/home/index.vue
// module id = null
// module chunks = 